module.exports = __webpack_public_path__ + "assets/img/04-l.65ab851.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/04-l.jpg
// module id = v+Dy
// module chunks = 0